import { __ } from '@wordpress/i18n';

export default {
	message: __( 'React is working :)', 'dhsv_theme' ),
	alertTitle: __( 'E-Mail-Adresse nicht bestätigt', 'dhsv_theme' ),
	alertDescription: __(
		'Bitte bestätige deine E-Mail-Adresse, um fortzufahren.',
		'dhsv_theme'
	),
	checklistDescription: __(
		'Die mit (*) markierten Felder sind Pflichtfelder',
		'dhsv_theme'
	),
	labels: {
		salutation: __( 'Anrede', 'dhsv_theme' ),
		title: __( 'Titel', 'dhsv_theme' ),
		firstname: __( 'Vorname', 'dhsv_theme' ),
		lastname: __( 'Nachname', 'dhsv_theme' ),
		phone: __( 'Telefon', 'dhsv_theme' ),
		phone_business: __( 'Telefon (Büro)', 'dhsv_theme' ),
		street_address: __( 'Straße', 'dhsv_theme' ),
		postal_code: __( 'Postleitzahl', 'dhsv_theme' ),
		city: __( 'Ort', 'dhsv_theme' ),
		email: __( 'E-Mail', 'dhsv_theme' ),
		password: __( 'Passwort', 'dhsv_theme' ),
		repeatPassword: __( 'Passwort wiederholen', 'dhsv_theme' ),
		checkTerms: __(
			'Ich habe die Datenschutzerklärung gelesen und stimme der Verarbeitung meiner Daten zu.',
			'dhsv_theme'
		),
		checkNewsletter: __(
			'Ich möchte den Newsletter erhalten.',
			'dhsv_theme'
		),
		requiredFields: __(
			'Die mit (*) markierten Felder sind Pflichtfelder',
			'dhsv_theme'
		),
		headlinePassword: __( 'Passwort vergeben', 'dhsv_theme' ),
		headlinePersonalData: __( 'Ihre persönlichen Daten', 'dhsv_theme' ),
	},
	buttonText: __( 'Absenden', 'dhsv_theme' ),
	buttonResetText: __( 'Zurücksetzen', 'dhsv_theme' ),
};
